import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
        title: 'Advanced Rent — Tenant Referencing & Insurance',
      },
      {
        path: 'for-agents',
        loadComponent: () =>
          import('./pages/for-agents/for-agents.component').then(
            (m) => m.ForAgentsComponent
          ),
        title: 'For Letting Agents — Advanced Rent',
      },
      {
        path: 'tenant-referencing',
        loadComponent: () =>
          import(
            './pages/tenant-referencing/tenant-referencing.component'
          ).then((m) => m.TenantReferencingComponent),
        title: 'Tenant Referencing — Advanced Rent',
      },
      {
        path: 'rent-guarantee-insurance',
        loadComponent: () =>
          import('./pages/rgi/rgi.component').then((m) => m.RgiComponent),
        title: 'Rent Guarantee Insurance — Advanced Rent',
      },
      {
        path: 'hmo-rent-guarantee-insurance',
        loadComponent: () =>
          import('./pages/hmo-rgi/hmo-rgi.component').then(
            (m) => m.HmoRgiComponent
          ),
        title: 'HMO Rent Guarantee Insurance — Advanced Rent',
      },
      {
        path: 'deposit-replacement',
        loadComponent: () =>
          import(
            './pages/deposit-replacement/deposit-replacement.component'
          ).then((m) => m.DepositReplacementComponent),
        title: 'Deposit Replacement Insurance — Advanced Rent',
      },
      {
        path: 'home-buyers-insurance',
        loadComponent: () =>
          import('./pages/home-buyers/home-buyers.component').then(
            (m) => m.HomeBuyersComponent
          ),
        title: 'Home Buyers Insurance — Advanced Rent',
      },
      {
        path: 'home-sellers-insurance',
        loadComponent: () =>
          import('./pages/home-sellers/home-sellers.component').then(
            (m) => m.HomeSellersComponent
          ),
        title: 'Home Sellers Insurance — Advanced Rent',
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./pages/contact/contact.component').then(
            (m) => m.ContactComponent
          ),
        title: 'Contact Us — Advanced Rent',
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./pages/legal/legal-page.component').then(
            (m) => m.LegalPageComponent
          ),
        data: { slug: 'terms-and-conditions' },
        title: 'Terms and Conditions — Advanced Rent',
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./pages/legal/legal-page.component').then(
            (m) => m.LegalPageComponent
          ),
        data: { slug: 'privacy-policy' },
        title: 'Privacy Policy — Advanced Rent',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
